var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.5,
    height: 89.5,
    viewBox: "0 0 89.5 89.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16331",
    "data-name": "Grupo 16331",
    transform: "translate(-675 -175)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44.25,
    cy: 44.25,
    r: 44.25,
    transform: "translate(675.5 175.5)",
    fill: "#fff4f5",
    stroke: "#e92243",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(715.001 196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2917",
    "data-name": "Fill 2917",
    d: "M0,0,1.083,32H7.8L8.816,0Z",
    transform: "translate(0)",
    fill: "#e92243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2918",
    "data-name": "Fill 2918",
    d: "M0,8.134H8.118V0H0Z",
    transform: "translate(0.422 38.866)",
    fill: "#e92243"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/WarningRed.2b883718a21b94ed683dfe951a48c7f9.svg";
export { ForwardRef as ReactComponent };